<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-01-13 14:37:26
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Notification\MessageType\components\viewMessageType.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-23 17:02:05
-->
<template>
  <normalDialog
    :title="$t('label_essweb_MessageType_list_dialog_viewTypeTitle')"
    :dialog="show"
    width="700"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
            <inputTextFiledMultiLang
              :readonly="!iSEdited"
              :filled="iSEdited"
              :bindData="Data.message_type_name"
              @change="
                (valueArr) => {
                  Data.message_type_name = valueArr;
                }
              "
              :label="
                $t('label_essweb_MessageType_list_dialog_messageTypeNameLabel')
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              v-model="Data.message_type_code"
              maxlength="100"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="$t('label_essweb_ClaimReason_form_codeLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_MessageType_list_dialog_messageTypeLabel")
            }}</v-sheet>
            <v-select
              :items="messageType"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              item-text="view_fields"
              item-value="value_field"
              :rules="$GetRules(['_Require_Rules'], [null])"
              dense
              :placeholder="
                $t('label_essweb_MessageType_list_dialog_messageTypeLabel')
              "
              v-model="Data.message_type"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template>
            </v-select>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0">
            <v-sheet class="text-subtitle-2">
              {{
                $t(
                  "label_essweb_MessageType_list_dialog_formEmailGroupTitleLabel"
                )
              }}:
            </v-sheet>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_MessageType_list_dialog_emailTemplateLabel")
            }}</v-sheet>
            <v-select
              :items="emailTemplate"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              item-text="view_fields"
              item-value="value_field"
              dense
              :placeholder="
                $t('label_essweb_MessageType_list_dialog_emailTemplateLabel')
              "
              v-model="Data.mail_mode_uuid"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template>
            </v-select>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0">
            <v-checkbox
              :disabled="!iSEdited"
              v-model="Data.is_mail_send"
              class="mt-0"
              :label="
                $t('label_essweb_MessageType_list_dialog_isSendEmailLabel')
              "
              hide-details
              required
            ></v-checkbox>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0">
            <v-sheet class="text-subtitle-2">
              {{
                $t(
                  "label_essweb_MessageType_list_dialog_formPushGroupTitleLabel"
                )
              }}:
            </v-sheet>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_MessageType_list_dialog_sendEmailTemplateLabel")
            }}</v-sheet>
            <v-select
              :items="notiTemplate"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              item-text="view_fields"
              item-value="value_field"
              dense
              :placeholder="
                $t(
                  'label_essweb_MessageType_list_dialog_sendEmailTemplateLabel'
                )
              "
              v-model="Data.message_mode_uuid"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template>
            </v-select>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_MessageType_list_dialog_sendPlatformLabel")
            }}</v-sheet>
            <v-select
              :items="platform"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              item-text="view_fields"
              item-value="value_field"
              :rules="$GetRules(['_Require_Rules'], [null])"
              dense
              :placeholder="
                $t('label_essweb_MessageType_list_dialog_sendPlatformLabel')
              "
              v-model="Data.message_platform"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template>
            </v-select>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
            <v-checkbox
              v-model="Data.is_message_send"
              :disabled="!iSEdited"
              class="mt-0"
              hide-details
              :label="
                $t(
                  'label_essweb_MessageType_list_dialog_isSendNotificationLabel'
                )
              "
              required
            ></v-checkbox>
          </v-col> </v-row></v-form
    ></template>
    <template v-slot:actions>
      <CardActions
        saveBtn
        v-if="iSEdited"
        @save="toSave"
        @cancel="closeDialog"
      />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newMessageType",
  props: {
    show: { default: false, type: Boolean },
    curUuid: { default: null, type: [Number, String] },
  },
  computed: {
    ...mapGetters(["companyLang"]),
    messageType() {
      return this.$getSelectTrans(this.messageTypeData, "view_fields");
    },
    emailTemplate() {
      return this.$getSelectTrans(this.emailTemplateData, "view_fields");
    },
    notiTemplate() {
      return this.$getSelectTrans(this.notiTemplateData, "view_fields");
    },
    platform() {
      return this.$getSelectTrans(this.platformData, "view_fields");
    },
  },
  watch: {
    curUuid(val) {
      if (val) this.getDetail(val);
    },
  },
  data() {
    return {
      messageTypeData: [],
      iSEdited: false,
      emailTemplateData: [],
      notiTemplateData: [],
      platformData: [],
      Data: {
        message_type_name: "",
        message_type_code: "",
        message_type: "",
        mail_mode_uuid: "",
        is_mail_send: false,
        is_message_send: false,
        message_mode_uuid: "",
        message_platform: "",
      },
    };
  },
  mounted() {
    const that = this;
    this.Data.message_type_name = this.$getCommonLangKey(this.companyLang);
    this.getMessageType();
    this.getEmailTemplate();
    this.getNotificationTemplate();
    this.getPlatform();
  },
  methods: {
    getDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_message_type",
        url: "/message-type/get-details/",
        data: { uuid: uuid },
      }).then((res) => {
        res.data["message_type_name_save"] = res.data.message_type_name;
        res.data.message_type_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.message_type_name
        );
        res.data.is_mail_send = Number(res.data.is_mail_send) ? true : false;
        res.data.is_message_send = Number(res.data.is_message_send)
          ? true
          : false;
        that.Data = res.data;
      });
    },
    getEmailTemplate: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_mail_mode",
      }).then((res) => {
        that.emailTemplateData = res.data;
      });
    },
    getNotificationTemplate: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_message_mode",
      }).then((res) => {
        that.notiTemplateData = res.data;
      });
    },
    getPlatform: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_message_platform",
      }).then((res) => {
        that.platformData = res.data;
      });
    },
    getMessageType: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_message_type",
      }).then((res) => {
        that.messageTypeData = res.data;
      });
    },
    closeDialog: function () {
      this.$emit("close");
    },
    toSave: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("save", this.Data);
    },
  },
};
</script>